import { Component, OnInit, ViewChild } from '@angular/core';
import { SimulacionesService } from 'src/app/services/simulaciones.service';
import { AuthService } from 'src/app/services/auth.service';
import { Matricula } from 'src/app/models/matriculas.model';
import { ProcesosActivosService } from 'src/app/services/procesosactivos.service';
import { ModalMessagesComponent } from 'src/app/shared/modal-messages/modal-messages.component';
import { GlobalVariable } from 'src/app/config/service.config';
declare var $: any;

@Component({
  selector: 'app-main',
  templateUrl: './main.component.html',
  styleUrls: ['./main.component.css'],
})
export class MainComponent implements OnInit {

  // Modales
  @ViewChild(ModalMessagesComponent, { static: true }) modalMessages: ModalMessagesComponent

  lista: Matricula[];
  user: any;
  BloqueoFinanciero = false;
  constructor(
    private simulacionesService: SimulacionesService,
    private auths: AuthService,
    private procesosActivosService: ProcesosActivosService
  ) {
    this.user = this.auths.GetUserToken();
    this.LoadActivas();
  }

  ngOnInit(): void {
    this.verificarBloqueos()
  }

  verificarBloqueos() {

    if (this.user.TieneMatricula && this.user.TieneMatricula != 'True') {
      console.log(this.user)
      console.log('[MAIN] TieneMatricula', 'SI')
     // this.modalMessages.addMessage('De acuerdo a nuestros registros tienes una matrícula activa en una de nuestras instituciones, sin embargo, podrás continuar y completar tu matrícula y posteriormente un ejecutivo de admisión tomará contacto contigo para regularizar la situación de tu matrícula anterior.')
    }


    //if (GlobalVariable.bloqueoFinanciero) {
    if (GlobalVariable.bloqueoAcademico) {
      if (this.user.BloqueoAcademico && (this.user.BloqueoAcademico === 'True' || this.user.BloqueoAcademico == 'true')) {
        console.log('[MAIN] BloqueoAcademico', 'SI')
        this.modalMessages.addMessage('De acuerdo a nuestros registros tienes una situación académica que regularizar, te solicitamos tomar contacto con la sede donde estudiaste anteriormente y regularizar tu situación antes de matricularte. Revisa contactos en <a href="https://www.tupuedes.cl/sistemas-de-admision/matricula-online/contacto-en-sede/">www.tupuedes.cl/sistemas-de-admision/matricula-online/contacto-en-sede/</a>')
      }
    }
    //}

    //if (GlobalVariable.bloqueoFinanciero) {
    /*
    if (this.user.BloqueoFinanciero && this.user.BloqueoFinanciero === 'True') {
      console.log('[MAIN] BloqueoFinanciero', 'SI')
      this.BloqueoFinanciero = true;
      this.modalMessages.addMessage('De acuerdo a nuestros registros tienes una situación financiera que regularizar, sin embargo, podrás continuar con tu proceso de matrícula y completarla, posteriormente un ejecutivo de admisión tomarácontacto para regularizar esta situación.')
    }
    */
    //}

    if (this.modalMessages.getMessagesLength() > 0)
      this.modalMessages.show();
  }

  LoadActivas() {
    this.simulacionesService.GetActivas(this.user.primarysid).subscribe(
      (data: Matricula[]) => {
        this.lista = data;
      },
      (err) => {
        console.log(err);
      },
      () => {
        // This is intentional
      }
    );
  }

  onCancelProceso(proceso: Matricula) {
    this.lista = null;
    this.procesosActivosService.procesosActivos$.emit('LOAD_PROCESOS');
    this.LoadActivas();
  }

}
